
import { Entry } from '@/models/generics'
import { RequestHandler } from '@Protium/vue-ozone-utils'
import { computed, defineComponent, onMounted, PropType, reactive, ref, toRefs, watch } from 'vue'
import Toggle from '@/components/Toggle.vue'
import { SkuController, SkuCtrl } from '../utils'
import { CtCatalogue } from '@/models/interfaces/content-type'
import { isUUID } from '@/utils'

export default defineComponent({
  name: 'CatalogueProductVariant',
  components: { Toggle },
  props: {
    id: {
      type: String,
      required: true
    },
    parent: {
      type: String,
      required: true
    },
    catalogue: {
      type: Object as PropType<CtCatalogue>
    },
    catalogueVariant: { // the catalogue-product entry, if it exists
      type: Object as PropType<Entry>
    },
    request: {
      type: Object as PropType<RequestHandler<any>>,
      required: true
    }
  },
  emits: ['update:catalogueVariant', 'add'],
  setup (props, { emit }) {
    const skuController = ref<SkuCtrl>(SkuController(props.catalogue))
    watch(() => props.catalogue, c => { skuController.value = SkuController(c) })

    const state = reactive({
      entry: null,
      triggerActivate: false,
      shouldActivate: !props.catalogueVariant
    })

    function emitAdd (value) {
      if (state.shouldActivate && value === true) {
        state.shouldActivate = false
        emit('add', state.entry, props.id)
      }
    }

    async function init () {
      try {
        if (!props.id || !isUUID(props.id)) {
          console.warn(`CatalogueProductVariant | props.id was ${isUUID(props.id) ? 'defined but not a valid uuid: ' : 'not defined'}`, props.id)
          return
        }
        const { items } = await props.request.get('id', [props.id])
        state.entry = (items || [])[0]
      } catch (e) {
        console.error('CatalogueProductVariant error', e)
      }
    }

    onMounted(init)

    return {
      ...toRefs(state),
      skuController,
      emitAdd,
      toggleActive: (active:boolean) => {
        emit('update:catalogueVariant', { ...props.catalogueVariant, active })
      },
      updatePrice: (price:number) => {
        emit('update:catalogueVariant', { ...props.catalogueVariant, price })
      }
    }
  }
})
